import { IStorageFilesListFilters } from '~/services/api/storageFiles/types';

const getInitialFilters = (): IStorageFilesListFilters => ({
  name: '',
  typeId: '',
  documentTypeId: '',
});

export default getInitialFilters;
